import { ActionsListFilters } from '@/modules/entity-actions-review/types';

export function getActionsListFilterKeys(): string[] {
    return [ ...Object.keys(new ActionsListFilters()), 'insuredId' ];
}
